import { render, staticRenderFns } from "./ExpensesAddonsList.vue?vue&type=template&id=6194a9c9&"
import script from "./ExpensesAddonsList.vue?vue&type=script&lang=js&"
export * from "./ExpensesAddonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports